import { CheckCircle, InfoOutlined } from '@mui/icons-material';
import { Box, IconButton, Typography } from '@mui/material';
import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';

import PartnerDialog from '../../components/partner-dialog';

function PartnerTerritory({
  partner,
}: {
  partner?: Partial<{
    code: string;
    icon: string | null;
    id: number;
    title: string;
  }> | null;
}): React.JSX.Element {
  const [partnerDialogOpen, openPartnerDialog] = useState(false);
  const { t } = useTranslation();

  return (
    <>
      {partner && partner.code !== 'geovelo' && (
        <Box
          alignItems="center"
          borderRadius={4}
          display="flex"
          gap={1}
          height={32}
          paddingX={1}
          sx={{ backgroundColor: 'rgba(224, 234, 249, 0.5)' }}
        >
          <CheckCircle color="primary" />
          <Typography color="primary" variant="body2">
            {t('geovelo.rides.detail.partner_territory')}
          </Typography>
          <IconButton onClick={() => openPartnerDialog(true)} size="small" sx={{ padding: 0 }}>
            <InfoOutlined fontSize="small" />
          </IconButton>
        </Box>
      )}
      {partner && (
        <PartnerDialog
          onClose={() => openPartnerDialog(false)}
          open={partnerDialogOpen}
          partner={partner}
        />
      )}
    </>
  );
}

export default PartnerTerritory;
